import {
  MIN_RESIZE_WIDTH,
  MIN_RESIZE_HEIGHT,
} from 'apps/studio/lib/utils/dnd'

export const validateDimensionChanges = ({ page, x, y, height, width }) => {
  const { originalWidth, originalHeight } = page

  if (width === '' || width < MIN_RESIZE_WIDTH) {
    return {
      errors: `Value must be greater than ${MIN_RESIZE_WIDTH}`,
    }
  }

  if (height === '' || height < MIN_RESIZE_HEIGHT) {
    return {
      errors: `Value must be greater than ${MIN_RESIZE_HEIGHT}`,
    }
  }

  if (Number(width) + x >= originalWidth + 1) {
    return {
      errors: `Width is outside the page`,
    }
  }

  if (Number(height) + y >= originalHeight + 1) {
    return {
      errors: `Height is outside the page`,
    }
  }

  return false
}

export const validatePositionChanges = ({ page, x, y, height, width }) => {
  const { originalWidth, originalHeight } = page

  if (x === '' || Number(x) < 0) {
    return {
      errors: `X position cannot be less than 0`,
    }
  }

  if (y === '' || Number(y) < 0) {
    return {
      errors: `Y position cannot be less than 0`,
    }
  }

  if (Number(x) + width >= originalWidth + 1 || Number(x) < 0) {
    return {
      errors: `X position is outside the page`,
    }
  }

  if (Number(y) + height >= originalHeight + 1 || Number(y) < 0) {
    return {
      errors: `Y position is outside the page`,
    }
  }
  return false
}
